import React from "react";
import AdditionalInfoComponent from "./additionalInfo.component";
import { useSelector } from "react-redux";

export default function AdditionalInfoContainer({ id, currentLanguage, isTemplateEditor, getTranslation }) {
  const { isVisible } = useSelector(
    (state) => isTemplateEditor
      ? state.products.template.workspaceSetting.setting.components[id]
      : state.productPage.components[id]
  );

  return isVisible && <AdditionalInfoComponent currentLanguage={currentLanguage} getTranslation={getTranslation} />;
}
